import  { useState, useEffect } from "react";

import { Box,  Grid, Typography,  Tooltip, TableContainer,  Divider,  Table, TableBody, TableHead,  TableCell, TableRow, IconButton,  useTheme, alpha } from "@mui/material";

import dayjs from "dayjs";

import Close from '@mui/icons-material/Close';
import 'dayjs/plugin/customParseFormat';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { tokens } from "../../../theme/theme";
import GlobalConfig from "../../../config/date/GlobalConfig";


import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import TableFilterRow from "../../../components/table/TableFilterRow";

import CustomTableContainer from "../../../components/table/CustomTableContainer";
import CustomPagination from "../../../components/table/CustomPagination";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import CustomDatePicker from "../../../components/CustomDatePicker";
import { exportToExcel } from "../../../components/ExportToExcel";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";

const JumboReport = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [loadingData, setLoadingData] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page
    const [currentPage, setCurrentPage] = useState(1);

    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
        // getFGStockReport();
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
        //getFGStockReport();
    };

    const getFGStockReport = () => {
        const formattedFromMODate = dayjs(FromDate).format('DD-MMM-YYYY');
        const formattedFromMODate1 = dayjs(ToDate).format('DD-MMM-YYYY');


        let parameters = {
            p_companyid: localStorage.getItem('companyid'),
            p_frommodate: formattedFromMODate,
            p_tomodate: formattedFromMODate1
        };
        setLoading(true);
        callApi(API_ENDPOINTS.REPORT_GetreportProductionGetParentRollDetails, 'POST', { 'Content-Type': 'application/json' }, parameters)
            .then(data => {
                // Update state with fetched data
                // Update state with fetched data
                if (data && data.length > 0) {
                    setLoadingData(data);
                    setLoading(false);
                }
                else {
                    setLoading(false);
                    setLoadingData([]);

                }
            })
            .catch(error => {
                alert(error);
            });

    };

    useEffect(() => {

        getFGStockReport();


    }, [FromDate, ToDate]);

    const [filters, setFilters] = useState({
        date: '',
        pr_number: '',
        shift_code: '',
        item_code: '',
        gsm: '',
        release_no: '',
        lot_no: '',
        reel_weight: '',
        remarks: '',
        status:''
    });

    const filteredData = loadingData.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    // // ✅ Excel Serial Date Conversion Helper
    // function convertToExcelDate(jsDate) {
    //     // Excel stores dates as number of days since 1899-12-31
    //     const epoch = Date.UTC(1899, 11, 30);
    //     const excelTime = (jsDate.getTime() - epoch) / (1000 * 60 * 60 * 24);
    //     return Math.floor(excelTime); // no time, only date
    // }

    // const handleExportToExcel = () => {
    //     // Prepare the data with headers
    //     const formattedData = filteredData.map(row => ({
    //         "DATE": row.date ? convertToExcelDate(new Date(row.date)) : "",
    //         "SHIFT": row.shift_code,
    //         "JUMBO NO": row.pr_number,
    //         "QUALITY": row.item_code,
    //         "GSM": row.gsm,
    //         "MO NO": row.release_no,
    //         "MA NO": row.lot_no,            
    //         "QUANTITY": isNaN(parseFloat(row.reel_weight)) ? row.reel_weight : parseFloat(row.reel_weight),
    //         "REMARKS": row.remarks,
    //     }));

    //     // Create a new worksheet with headers
    //     const worksheet = XLSX.utils.json_to_sheet(formattedData);


    //     // Manually set DATE column to number type and apply date format
    //     const range = XLSX.utils.decode_range(worksheet['!ref']);
    //     for (let row = range.s.r + 1; row <= range.e.r; row++) {
    //         const cellAddress = XLSX.utils.encode_cell({ r: row, c: 0 }); // Column A
    //         const cell = worksheet[cellAddress];
    //         if (cell && typeof cell.v === "number") {
    //             cell.t = 'n'; // number type
    //             cell.z = 'dd-mm-yyyy'; // Excel will use this display format (when using compatible reader)
    //         }
    //     }


    //     // Header styling (optional, won't affect date issue)
    //     for (let col = range.s.c; col <= range.e.c; col++) {
    //         const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
    //         if (!worksheet[cellAddress]) continue;
    //         worksheet[cellAddress].s = {
    //             alignment: { vertical: 'center', horizontal: 'center' },
    //             font: { bold: true },
    //             border: {
    //                 top: { style: 'thin' }, bottom: { style: 'thin' },
    //                 left: { style: 'thin' }, right: { style: 'thin' },
    //             },
    //         };
    //     }

    //     // All cells border
    //     for (let row = range.s.r; row <= range.e.r; row++) {
    //         for (let col = range.s.c; col <= range.e.c; col++) {
    //             const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
    //             if (!worksheet[cellAddress]) continue;
    //             worksheet[cellAddress].s = {
    //                 ...worksheet[cellAddress].s,
    //                 border: {
    //                     top: { style: 'thin' }, bottom: { style: 'thin' },
    //                     left: { style: 'thin' }, right: { style: 'thin' },
    //                 },
    //             };
    //         }
    //     }

    //     // Create a new workbook and append the styled worksheet
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Jumbo Roll Details");

    //     // Get current date and time in ddmmyyyy and HHMM format
    //     const now = new Date();
    //     const day = String(now.getDate()).padStart(2, '0');
    //     const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    //     const year = now.getFullYear();
    //     const hours = String(now.getHours()).padStart(2, '0');
    //     const minutes = String(now.getMinutes()).padStart(2, '0');

    //     // Format filename as ddmmyyyy_HHMM
    //     const dateTime = `${day}${month}${year}_${hours}${minutes}`;
    //     const fileName = `Jumbo Roll Production Detail Report.xlsx`;

    //     // Export the file
    //     XLSX.writeFile(workbook, fileName);
    // }; 

    const excelColumns = [
        { header: "DATE", key: "date" },
        { header: "SHIFT", key: "shift_code" },
        { header: "JUMBO NO", key: "pr_number" },
        { header: "QUALITY", key: "item_code" },
        { header: "GSM", key: "gsm" },
        { header: "MO NO", key: "release_no" },
        { header: "MA NO", key: "lot_no" },
        { header: "Customer", key: "customer" },
        { header: "Consignee", key: "supplier" },
        { header: "QUANTITY", key: "reel_weight" },
        { header: "RE PULP QUANTITY", key: "re_pulp_qty" },
        { header: "REMARKS", key: "remarks" },
        { header: "STATUS", key: "status" },
    ];

    const dateColumnIndexes = [0]; // "DATE"
    

    const handleExportToExcel = () => {
        exportToExcel({
            data: filteredData,
            fileName: 'Jumbo Roll Production Detail Report.xlsx',
            sheetName: 'Jumbo Roll Details',
            columns: excelColumns,           // 🔁 Fixed name
            dateColumnIndexes,

        });
    };

    const HandleClose = () => {
        handleExportToExcel();
    }

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const pageCount = Math.ceil(filteredData.length / recordsPerPage);
    const uniqueValues = {
        pr_number: [...new Set(loadingData.map(row => row.pr_number))],
        shift_code: [...new Set(loadingData.map(row => row.shift_code))],
        item_code: [...new Set(loadingData.map(row => row.item_code))],
        gsm: [...new Set(loadingData.map(row => row.gsm))],
        release_no: [...new Set(loadingData.map(row => row.release_no))],
        lot_no: [...new Set(loadingData.map(row => row.lot_no))],

    };



    // Get the records for the current page
    const currentRecords = filteredData.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );



    const columns = ['date', 'shift_code', 'pr_number', 'item_code', 'gsm', 'release_no', 'lot_no','customer','supplier' ,'reel_weight','re_pulp_qty', 'remarks','status'];

    const autoCompleteColumns = ['pr_number', 'shift_code', 'item_code', 'gsm', 'release_no', 'lot_no','customer','supplier'];

    const totals = {
        reel_weight: filteredData.reduce((sum, r) => sum + (parseFloat(r.reel_weight) || 0), 0),
        re_pulp_quantity: filteredData.reduce((sum, r) => sum + (parseFloat(r.re_pulp_qty) || 0), 0),
    };   

    return (
        <>
            <Box display="flex" flexDirection={'column'}>
                <Box m='0px' display="flex" justifyContent={'space-between'}>
                    <Grid container justifyContent="start" alignItems={'center'} style={{ marginTop: '0px' }}>
                        <Box marginRight="auto" ml={1} >
                            <Typography variant="h4" color={colors.grey[100]} fontWeight="semi bold" >Jumbo Roll Production Detail Report</Typography>
                        </Box>

                        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                        <Grid item lg={2.5} xs={4} xl={2.5}>
                            <CustomDatePicker
                                value={FromDate}
                                onChange={(date) => handleDateChange2(date)}
                                autoFocus={true}
                            />
                        </Grid>

                        <Grid item mt="2px" ml="10px" mr="10px">
                            <Typography fontWeight="bold">-</Typography>
                        </Grid>

                        <Grid item lg={2.5} xs={4} xl={2.5}>
                            <CustomDatePicker
                                value={ToDate}
                                onChange={(date) => handleDateChange1(date)}
                            />
                        </Grid>
                    </Grid>

                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                    <Tooltip title="Download Report" onClick={HandleClose}>
                        <IconButton >
                            <FileDownloadIcon />
                        </IconButton>
                    </Tooltip>

                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                    <Grid item mt="5px" ml="2px" mr="7px" justifyContent="center">
                        <IconButton onClick={() => { handleBackWinderMachineEntry() }}>
                            <Close style={{ fontSize: "17px", color: "#2196F3" }} />
                        </IconButton>
                    </Grid>
                </Box>
            </Box>

            <Divider />
            <ResponsiveBox colors={colors} customMaxHeight={{ xs: '72vh', sm: '72vh', md: '74vh', lg: '74vh', xl: '82vh' }}>

                <CustomTableContainer colors={colors}>

                    <TableContainer  >
                        {loading ? (
                            <SkeletonTableLoader rows={5} columns={11} />
                        ) : (

                            <Table stickyHeader size="small" >
                                <TableHead sx={{ height: 10 }}>
                                    <TableRow>
                                        <TableCell>
                                            DATE
                                        </TableCell>

                                        {/* <TableCell onClick={() => handleSort('date')} sx={{ cursor: 'pointer',textAlign: "center", minWidth: 100, whiteSpace: "nowrap" }}>DATE</TableCell> */}
                                        <TableCell sx={{ textAlign: "center", minWidth: 100, whiteSpace: "nowrap" }}>SHIFT</TableCell>
                                        <TableCell sx={{ textAlign: "center", minWidth: 130, whiteSpace: "nowrap" }}>JUMBO NO.</TableCell>
                                        <TableCell sx={{ textAlign: "center", minWidth: 150, whiteSpace: "nowrap" }} >QUALITY</TableCell>
                                        <TableCell>GSM</TableCell>
                                        <TableCell>MO NO</TableCell>
                                        <TableCell>MA NO</TableCell>                                        
                                         <TableCell>Customer</TableCell>
                                         <TableCell>Consignee</TableCell>
                                        <TableCell>QUANTITY</TableCell>
                                        <TableCell>REPULP QUANTITY</TableCell>
                                        <TableCell>REMARKS</TableCell>
                                        <TableCell>STATUS</TableCell>
                                    </TableRow>

                                    <TableFilterRow
                                        columns={columns}
                                        filters={filters}
                                        handleFilterChange={handleFilterChange}
                                        uniqueValues={uniqueValues}
                                        autoCompleteColumns={autoCompleteColumns}
                                    />

                                </TableHead>
                                <TableBody>
                                    {currentRecords.map((row, index) => (
                                        <TableRow key={row.id} sx={{

                                            backgroundColor:
                                                index % 2 === 0
                                                    ? theme.palette.background.default
                                                    : alpha(theme.palette.action.hover, 0.04), // slightly darker
                                        }}>

                                            <TableCell>{row.date}</TableCell>
                                            <TableCell>{row.shift_code}</TableCell>
                                            <TableCell>{row.pr_number}</TableCell>
                                            <TableCell>{row.item_code}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.gsm}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.release_no}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.lot_no}</TableCell>                                            
                                            <TableCell sx={{ textAlign: "right" }}>{row.customer}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.supplier}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.reel_weight}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.re_pulp_qty}</TableCell>
                                            <TableCell>{row.remarks}</TableCell>
                                            <TableCell>{row.status}</TableCell>
                                        </TableRow>

                                    ))}

                                    <TableRow sx={{ backgroundColor: colors.primary[400], height: 25 }}>
                                        <TableCell colSpan={9} sx={{ marginRight: '5px', fontWeight: 'bold', textAlign: 'right', }}>TOTAL </TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.reel_weight.toFixed(2)}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.re_pulp_quantity.toFixed(2)}</TableCell>
                                        <TableCell /> 
                                        <TableCell /> 
                                    </TableRow>


                                </TableBody>
                            </Table>
                        )}

                    </TableContainer>
                </CustomTableContainer>
            </ResponsiveBox>
            <CustomPagination pageCount={pageCount} currentPage={currentPage} onPageChange={handlePageChange} />



        </>
    )
};
export default JumboReport;